import React, {Fragment} from 'react'

import Reflux from 'reflux-react-16'
import moment from 'moment'
import _ from 'lodash'
import aSync from 'async'
import {RRule} from 'rrule'
import csvExport from '../../utils/csvExport.js'
import {getDeliveryZoneNames} from '../../utils/deliveryZones.js'
import {getPriceTableName} from '../../utils/priceTables.js'
import {getOrderFeesText} from '@utils/orderFees.js'
import {parsePrice} from '../../../utils/price.js'
import socket from '../../socketio/socketio.js'
import {emit} from '../../socketio/socketEmit.js'

import OrderStore from '../../stores/OrderStore.js'
import OrderActions from '../../actions/OrderActions.js'
import ParcelStore from '../../stores/ParcelStore.js'
import CustomerStore from '../../stores/CustomerStore.js'
import UserStore from '../../stores/UserStore.js'
import AddressStore from '../../stores/AddressStore.js'
import AddressActions from '../../actions/AddressActions.js'
import dbCodes from '../../../server/dbCodes.js'
import {getListAddresses, getOriginalOrderAddresses} from '../../../utils/retourAddresses.js'
import {copyColli} from '../../../utils/copyColli.js'

import {Alert, Button, SplitButton, IconButton, Colors, S1, P, Popup, Tabs, Tab, PdfModal, Panel, Row, MenuButton, Icon, ToolTip, Stack} from '../../components/UI/index.js'
import SelectRoute from '../../components/routes/SelectRoute.js'
import CreatePlanningPopup from '../../components/routes/CreatePlanningPopup.js'
import ViewOrderModal from '../../components/orders/ViewOrderModal.js'
import EditOrderModal from '../../components/orders/EditOrderModal.js'
import NewOrder from '../../../server/functions/orders/NewOrder.js'
import OrderScanModal from '../../components/orders/OrderScanModal.js'
import {fromLabelCallback, printLabels} from '../../components/labels/printLabels.js'
import ImportOrders from '../../components/orders/ImportOrders.js'
import AtHubOrderPopup from '../../components/orders/AtHubOrderPopup.js'
import RescheduleOrderPopup from '../../components/orders/RescheduleOrderPopup.js'
import PickupDeliverPopup from '../../components/orders/PickupDeliverPopup.js'
import CompleteOrderPopup from '../../components/orders/CompleteOrderPopup.js'
import AddressTypeIcon from '../../components/orders/AddressTypeIcon.js'

import Table from '../../components/UI/table/index.js'
import SearchBar from '../../components/SearchBar/index.js'

import Planning from './Planning.js'
import CancelOrderPopup from '../../components/orders/CancelOrderPopup.js'
import OnHoldOrderPopup from '../../components/orders/OnHoldOrderPopup.js'
import ReturnOrderPopup from '../../components/orders/ReturnOrderPopup.js'
import NotSuppliedOrderPopup from '../../components/orders/NotSuppliedOrderPopup.js'
import MancoOrderPopup from '../../components/orders/MancoOrderPopup.js'
import ChangeTimeslotPopup from '../../components/orders/ChangeTimeslotPopup.js'
import CreateTemplatesPopup from '../../components/orders/CreateTemplatesPopup.js'
import EditRouteModal from '../../components/routes/EditRouteModal.js'
import ExportOrders from '../../components/orders/ExportOrders.js'
import {withVehiclesHook} from '../../stores/VehicleStore.js'
import LoginStore from '../../stores/LoginStore.js'
import OrderTemplates from './OrderTemplates.js'
import time from 'server/utils/time.js'
import t from 'src/helpers/Languages.js'
import {getAvailableBranches} from 'src/utils/branches.js'
import branchesAvailable from '@utils/branchesAvailable.js'
import {formSpacing} from '../../components/UI/forms/index.js'
import createMemo from '../../utils/createMemo.js'
import externalCarrierNames from '../../../utils/externalCarriers.js'

class Dashboard extends Reflux.Component {
    constructor(props) {
        super(props)

        this.columnsMemo = createMemo()

        this.state = {
            selectedMessengers: ['', ''],
            printerPageSize: localStorage.printerPageSize || 'A6',
            exportOrdersIsOpen: false,
            ordersSubView: 'orders'
        }

        this.stores = [LoginStore, OrderStore, ParcelStore, CustomerStore, UserStore, AddressStore]

        // Bound once: OrderTemplates builds its columns again for a new function
        this.onClickEditTemplate = this.onClickEditTemplate.bind(this)
    }

    componentDidMount() {
        const {reseller} = this.props
        let {orderId = ''} = this.props.match.params

        document.title = `Planning • ${reseller.settings.accountName || reseller.name}`

        if (this.props.location?.state?.orderId) {
            this.viewOrderModal.open(this.props.location?.state?.orderId, this.props.location?.state?.fromScan && this.onClickScan.bind(this))
        }

        const urlParams = new URLSearchParams(window.location.search)
        const urlView = urlParams.get('view')
        const startDate = urlParams.get('startDate')
        const endDate = urlParams.get('endDate')
        const datesFromUrl = !orderId && startDate && endDate

        if (!orderId) {
            orderId = urlParams.get('orderId')

            const filterOn = urlParams.get('filter')
            const filterValue = urlParams.get('filterValue')

            // With a view the dates are set below
            if (datesFromUrl && !urlView) {
                this.onChangeDates(startDate, endDate)
            }

            // A route to focus (from the Routes table), once the routes of its date are loaded: the map zooms to a
            // route when it gets the focus
            if (urlParams.get('routeId') && datesFromUrl) {
                this.pendingRouteFocus = {routeId: urlParams.get('routeId'), date: startDate}
            }

            if (filterOn && filterValue) {
                this.onChangeQueries([{title: filterOn, operator: '=', text: filterValue}])
            }

            urlParams.delete('startDate')
            urlParams.delete('endDate')
            urlParams.delete('filter')
            urlParams.delete('filterValue')
            urlParams.delete('routeId')

            if (urlParams.toString()) {
                window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`)
            } else {
                window.history.replaceState({}, '', window.location.pathname)
            }
        }

        if (orderId) {
            this.viewOrderModal.open(orderId)
        }

        if (urlView) {
            // The dates of a link over the ones of the store
            const orderStartDate = datesFromUrl ? startDate : this.state.orderStartDate
            const orderEndDate = datesFromUrl ? endDate : this.state.orderEndDate || orderStartDate

            if (urlView === 'planning') {
                OrderActions.setDates(orderStartDate, orderStartDate)
            } else {
                OrderActions.setDates(orderStartDate, orderEndDate)
            }

            this.setState({view: urlView === 'planning' ? 'routes' : 'orders'})
        }

        window.history.replaceState({}, '')
    }

    componentDidUpdate(prevProps, prevState) {
        const {view} = this.state

        if (this.pendingRouteFocus && prevState.ordersLoading && !this.state.ordersLoading && this.state.orderStartDate === this.pendingRouteFocus.date) {
            if (this.state.routes[this.pendingRouteFocus.routeId]) {
                OrderActions.setRouteFocus(this.pendingRouteFocus.routeId)
            }

            this.pendingRouteFocus = null
        }

        const urlParams = new URLSearchParams(window.location.search)
        let urlView = urlParams.get('view')

        urlView = urlView ? (urlView === 'planning' ? 'routes' : 'orders') : 'routes'

        if (urlView !== view) {
            if (urlView === 'routes') {
                OrderActions.setDates(this.state.orderStartDate, this.state.orderStartDate)
            } else {
                OrderActions.setDates(this.state.orderStartDate, this.state.orderEndDate || this.state.orderStartDate)
            }

            this.setState({view: urlView})
        }

        if (this.state.orderLimitWarning) {
            this.setState({orderLimitWarning: false})
            this.alertPopup.openAlert('Waarschuwing', 'Je huidige datumrange bevat meer dan 35 000 ritten, hierdoor worden niet alle ritten weergegeven. Verklein de datumrange om dit te voorkomen. ')
        }
    }

    // The same columns until a value they read changes: new columns re-render every row of the table
    columns() {
        return this.columnsMemo([this.props.reseller, this.props.user, this.props.vehicles, this.state.routes, this.state.partners], () => this.buildColumns())
    }

    buildColumns() {
        const {reseller, user, vehicles} = this.props

        const getCarrierName = (order) => {
            if (order.handledBy === 'reseller') return reseller.settings.accountName || reseller.name
            if (order.handledBy === 'external') return externalCarrierNames[order.externalCarrierId] || ''
            return this.state.partners?.[order.carrierId]?.name || ''
        }

        return [
            ...branchesAvailable(reseller) ?
                [{id: 'branchName', title: t('branch'), visible: false, key: 'branchName', width: 180, text: (order) => {
                    const branch = reseller.settings.branches?.find((branch) => branch.id === order?.branchId)
                    return branch?.name || ''
                }}] :
                [],
            {id: 'date', title: 'Datum', visible: false, key: 'date', width: 120, text: (order) => {
                return moment(order.date).format('DD-MM-YYYY')
            }, sort: (order) => order.date},
            {id: 'createdTime', title: 'Aanmaaktijd', visible: false, key: 'createdTime', width: 120, sort: (order) => {
                return moment(new Date(parseInt(order._id.substring(0, 8), 16) * 1000)).format('HH:mm')
            }, text: (order) => {
                return moment(new Date(parseInt(order._id.substring(0, 8), 16) * 1000)).format('HH:mm')
            }},
            {id: 'customer', title: 'Klant', visible: true, width: 200, key: 'customer', sort: (order) => {
                return `${order.senderAddress?.name || ''}${order.senderAddress?.name ? ` (${order.customerAddress?.name})` : order.customerAddress?.name}`
            }, text: (order) => {
                return `${order.senderAddress?.name || ''}${order.senderAddress?.name ? ` (${order.customerAddress?.name})` : order.customerAddress?.name}`
            }},
            {id: 'startTime', title: 'Tijdvak', key: 'startTime', visible: true, width: 90, sort: (order, option) => {
                // Without a choice: the start time of the first address
                if (option === 'startTime' || option === 'endTime') {
                    let time = '24:00'

                    order.addresses.forEach((address) => {
                        if (address[option] < time) {
                            time = address[option]
                        }
                    })

                    return time
                }

                return order.addresses[0].startTime
            },
            dropdown: {
                legacyKey: 'timeSortOption',
                options: [
                    {
                        label: 'Starttijd',
                        value: 'startTime'
                    },
                    {
                        label: 'Eindtijd',
                        value: 'endTime'
                    }
                ]
            },
            render: (order) => {
                const {firstAddress, lastAddress} = getListAddresses(order)

                return (
                    <div style={{width: '100%'}}>
                        {firstAddress &&
                            <div style={{display: 'flex', alignItems: 'center', height: 27.5}}>
                                <P ellipsis style={{marginRight: 12}}>{`${firstAddress.startTime} - ${firstAddress.endTime}`.trim()}</P>
                            </div>
                        }

                        {lastAddress &&
                            <div style={{display: 'flex', alignItems: 'center', height: 27.5}}>
                                <P ellipsis style={{marginRight: 12}}>{`${lastAddress.startTime} - ${lastAddress.endTime}`.trim()}</P>
                            </div>
                        }
                    </div>
                )
            }},
            {id: 'address', title: 'Adres', key: 'address', visible: true, minWidth: 250, sort: (order, option) => {
                return order.addresses[0][option]
            }, dropdown: {
                legacyKey: 'addressSortOption',
                defaultValue: 'postalCode',
                options: [
                    {
                        label: 'Naam',
                        value: 'name'
                    },
                    {
                        label: 'Straat',
                        value: 'street'
                    },
                    {
                        label: 'Huisnummer',
                        value: 'nr'
                    },
                    {
                        label: 'Postcode',
                        value: 'postalCode'
                    },
                    {
                        label: 'Plaats',
                        value: 'city'
                    },
                    {
                        label: 'Stopnummer',
                        value: 'stopNumber'
                    }
                ]
            }, flex: 4, render: (order) => {
                const {firstAddress, lastAddress, firstIsOriginal, retourAddress, nrOfOtherAddresses} = getListAddresses(order)

                return (
                    <div style={{width: '100%'}}>
                        {firstAddress &&
                            <div style={{display: 'flex', alignItems: 'center', opacity: firstIsOriginal ? 0.6 : 1}}>
                                <AddressTypeIcon address={firstAddress} isRetour={firstAddress === retourAddress} disabled={firstIsOriginal} />

                                {!firstAddress.position && !firstIsOriginal &&
                                    <ToolTip text='Adres niet gevonden. Controleer de gegevens voor je bevestigt.'>
                                        <Icon size='md' style={{marginRight: 6, color: Colors.errorBright}} icon='mdi mdi-alert' />
                                    </ToolTip>
                                }

                                <P ellipsis style={{width: 150, marginRight: 6}}>
                                    {firstAddress.name}
                                </P>

                                <S1 ellipsis style={{marginRight: 6}}>
                                    {order.handledBy !== 'partner' && !firstIsOriginal && firstAddress.stopNumber}
                                </S1>

                                <P ellipsis style={{flex: 1}}>
                                    {`${firstAddress.street} ${firstAddress.nr}${firstAddress.addition} ${firstAddress.city}`.trim()}
                                </P>

                                {nrOfOtherAddresses > 0 &&
                                    <S1 style={{marginRight: 15, whiteSpace: 'nowrap'}}>+ {nrOfOtherAddresses}</S1>
                                }
                            </div>
                        }

                        {lastAddress &&
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <AddressTypeIcon address={lastAddress} isRetour={lastAddress === retourAddress} />

                                {(lastAddress === retourAddress ? !lastAddress.position : (_.some(order.addresses.slice(1), (address) => !address.position) || !lastAddress.position)) &&
                                    <Icon size='md' style={{marginRight: 6, color: Colors.errorBright}} icon='mdi mdi-alert' />
                                }

                                <P ellipsis style={{width: 150, marginRight: 6}}>
                                    {lastAddress.name}
                                </P>

                                <S1 ellipsis style={{marginRight: 6}}>
                                    {order.handledBy !== 'partner' && lastAddress.stopNumber}
                                </S1>

                                <P ellipsis style={{flex: 1}}>
                                    {`${lastAddress.street} ${lastAddress.nr}${lastAddress.addition} ${lastAddress.city}`.trim()}
                                </P>
                            </div>
                        }
                    </div>
                )
            }},
            {id: 'addressType', title: 'Adres type', key: 'addressType', visible: false, width: 50, render: (order) => {
                const {firstAddress, lastAddress, firstIsOriginal, retourAddress} = getListAddresses(order)

                return (
                    <div style={{width: '100%'}}>
                        {firstAddress && <AddressTypeIcon address={firstAddress} isRetour={firstAddress === retourAddress} disabled={firstIsOriginal} />}
                        {lastAddress && <AddressTypeIcon address={lastAddress} isRetour={lastAddress === retourAddress} />}
                    </div>
                )
            }},
            {id: 'addressName', title: 'Adres naam', key: 'addressName', visible: false, width: 300, render: (order) => {
                const {firstAddress, lastAddress} = getListAddresses(order)

                return (
                    <div style={{width: '100%'}}>
                        {firstAddress && <P ellipsis>{firstAddress.name}</P>}
                        {lastAddress && <P ellipsis>{lastAddress.name}</P>}
                    </div>
                )
            }},
            {id: 'addressStreet', title: 'Adres straat', key: 'addressStreet', visible: false, width: 300, render: (order) => {
                const {firstAddress, lastAddress} = getListAddresses(order)

                return (
                    <div style={{width: '100%'}}>
                        {firstAddress && <P ellipsis>{firstAddress.street} {firstAddress.nr}{firstAddress.addition}</P>}
                        {lastAddress && <P ellipsis>{lastAddress.street} {lastAddress.nr}{lastAddress.addition}</P>}
                    </div>
                )
            }},
            {id: 'addressPostalCode', title: 'Adres postcode', key: 'addressPostalCode', visible: false, width: 200, render: (order) => {
                const {firstAddress, lastAddress} = getListAddresses(order)

                return (
                    <div style={{width: '100%'}}>
                        {firstAddress && <P ellipsis>{firstAddress.postalCode}</P>}
                        {lastAddress && <P ellipsis>{lastAddress.postalCode}</P>}
                    </div>
                )
            }},
            {id: 'addressCity', title: 'Adres plaats', key: 'addressCity', visible: false, width: 200, render: (order) => {
                const {firstAddress, lastAddress} = getListAddresses(order)

                return (
                    <div style={{width: '100%'}}>
                        {firstAddress && <P ellipsis>{firstAddress.city}</P>}
                        {lastAddress && <P ellipsis>{lastAddress.city}</P>}
                    </div>
                )
            }},
            {id: 'addressInstructions', title: 'Adres instructies', key: 'addressInstructions', visible: false, width: 200, sort: (order) => {
                const {firstAddress, lastAddress} = getListAddresses(order)

                return `${firstAddress?.instructions || ''}${lastAddress?.instructions || ''}`
            }, render: (order) => {
                const {firstAddress, lastAddress} = getListAddresses(order)

                return (
                    <div style={{width: '100%'}}>
                        {firstAddress && <P ellipsis>{firstAddress.instructions}</P>}
                        {lastAddress && <P ellipsis>{lastAddress.instructions}</P>}
                    </div>
                )
            }},
            {id: 'addressDeliveryZone', title: 'Adres bezorggebied', key: 'addressDeliveryZone', visible: false, width: 200, sort: (order) => {
                const {firstAddress, lastAddress} = getListAddresses(order)

                return `${getDeliveryZoneNames(reseller, firstAddress?.deliveryZoneId).join(', ')}${getDeliveryZoneNames(reseller, lastAddress?.deliveryZoneId).join(', ')}`
            }, render: (order) => {
                const {firstAddress, lastAddress} = getListAddresses(order)

                return (
                    <div style={{width: '100%'}}>
                        {firstAddress && <P ellipsis>{getDeliveryZoneNames(reseller, firstAddress.deliveryZoneId).join(', ')}</P>}
                        {lastAddress && <P ellipsis>{getDeliveryZoneNames(reseller, lastAddress.deliveryZoneId).join(', ')}</P>}
                    </div>
                )
            }
            },
            {id: 'options', title: 'Adres opties', key: 'options', visible: false, render: (order) => {
                const options = []
                const processedCustomOptions = []

                order.addresses.forEach((address) => {
                    Object.entries(dbCodes.pickupAndDeliveryOptions).forEach(([key, value]) => {
                        if (!options.some((option) => option.value === value)) {
                            if (address[key]) {
                                options.push({type: 'standard', value})
                            }
                        }
                    })

                    if (address.minimumAge) {
                        if (address.minimumAge === 16) {
                            options.push({type: 'standard', value: dbCodes.pickupAndDeliveryOptions['minimumAge +16']})
                        } else if (address.minimumAge === 18) {
                            options.push({type: 'standard', value: dbCodes.pickupAndDeliveryOptions['minimumAge +18']})
                        } else if (address.minimumAge === 21) {
                            options.push({type: 'standard', value: dbCodes.pickupAndDeliveryOptions['minimumAge +21']})
                        }
                    }

                    if (address.customOptions) {
                        const customOptions = reseller.settings.orders.customOptions?.filter((option) => address.customOptions.includes(option.id))
                        customOptions.forEach((customOption) => {
                            if (!processedCustomOptions.includes(customOption.id)) {
                                options.push({
                                    type: 'custom',
                                    value: customOption.name,
                                    color: customOption.color,
                                    id: customOption.id
                                })
                                processedCustomOptions.push(customOption.id)
                            }
                        })
                    }
                })

                return (
                    <P ellipsis>
                        {options.map((option, idx) => {
                            const isLast = idx === options.length - 1
                            if (option.type === 'standard') {
                                return (
                                    <span key={option.value}>
                                        {option.value}{!isLast ? ', ' : ''}
                                    </span>
                                )
                            }

                            return (
                                <Fragment key={option.id}>
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            background: option.color,
                                            color: Colors.isDarkBackground(option.color) ? Colors.textLight : Colors.textDark,
                                            borderRadius: 24,
                                            padding: '0 8px',
                                            marginRight: isLast ? 0 : 4,
                                            fontSize: 12,
                                            lineHeight: '20px',
                                            verticalAlign: 'middle',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {option.value}
                                    </span>
                                </Fragment>
                            )
                        })}
                    </P>
                )
            }},
            {id: 'addressesAmount', title: 'Aantal adressen in rit', key: 'addressesAmount', visible: false, width: 100, text: (order) => {
                return order.addresses.length
            }},
            {id: 'pickupAddress', title: 'Ophaaladres', key: 'pickupAddress', filterOnly: true},
            {id: 'deliveryAddress', title: 'Bezorgadres', key: 'deliveryAddress', filterOnly: true},
            {id: 'colli', title: 'Aantal colli', visible: false, key: 'colli', width: 200, text: (order) => {
                return order.colli.length
            }},
            {id: 'notes', title: 'Opmerkingen', visible: true, key: 'notes', flex: 1},
            {id: 'reference', title: 'Referentie', visible: false, key: 'reference', flex: 1},
            {id: 'trackTrace', title: 'Track & Trace', visible: false, width: 200, key: 'trackTrace', onClick: (order) => {
                if (order.noTrackTrace) {
                    return
                }

                window.open(`/track&trace/${order.trackTrace}`)
            }},
            {id: 'barcodes', title: 'Barcodes', visible: false, width: 200, text: (order) => {
                return order.colli?.map((collo) => collo.barcode || '').filter((b) => b).join(', ') || ''
            }},
            {id: 'price', title: 'Prijs', visible: false, key: 'price', width: 70, sort: (order) => {
                if (order.price === 'priceScale') {
                    return parsePrice(order.priceScaleRange?.min)
                }

                return parsePrice(order.price)
            }, text: (order) => {
                if (order.price === 'priceScale') {
                    if (order.priceScaleRange) {
                        return `€ ${order.priceScaleRange.min} - € ${order.priceScaleRange.max}`
                    }

                    return `n.t.b.`
                }

                return `€ ${order.price}`
            }},
            {id: 'priceTableId', title: t('priceTable'), visible: false, key: 'priceTableId', width: 180, text: (order) => {
                return getPriceTableName(reseller.settings.orders.prices, order.priceTableId)
            }},
            {id: 'fees', title: 'Toeslagen', visible: false, key: 'fees', width: 250, sort: (order) => {
                return getOrderFeesText(order, reseller)
            }, text: (order) => {
                return getOrderFeesText(order, reseller)
            }},
            {id: 'routeName', title: 'Route', visible: true, key: 'routeName', width: 180, text: (order) => {
                const route = this.state.routes[order.routeId]
                return route?.name || ''
            }},
            {id: 'vehicleId', title: 'Voertuig', visible: false, key: 'vehicleId', width: 180, text: (order) => {
                const route = this.state.routes[order.routeId]
                const vehicle = vehicles?.find((vehicle) => vehicle._id === route?.vehicleId)
                return vehicle?.name || ''
            }},
            {id: 'vehicleType', title: 'Voertuigsoort', visible: false, key: 'vehicleType', width: 180, text: (order) => {
                const route = this.state.routes[order.routeId]
                const vehicleType = reseller.settings.vehicleTypes.find((vt) => vt._id === route?.vehicleTypeId)
                return vehicleType?.name || ''
            }},
            {id: 'messengerName', title: 'Koerier', visible: true, key: 'messengerName', width: 180, text: (order) => {
                return (order.routeId ? this.state.routes[order.routeId]?.messengerName : '') || ''
            }},
            {id: 'carrierLogo', title: t('carrier'), visible: false, key: 'carrierLogo', width: 180, render: (order) => {
                return <img style={{objectFit: 'contain', height: 40, maxWidth: 80}} src={order.handledBy === 'reseller' ? reseller.settings.logo : this.state.partners?.[order.carrierId]?.logo || ''} />
            }, sort: (order) => {
                return getCarrierName(order)
            }},
            {id: 'carrierId', title: t('carrierName'), visible: false, key: 'carrierId', width: 180, text: (order) => {
                return getCarrierName(order)
            }},
            ...reseller.permissions.shifts ?
                [{id: 'shift', title: 'Dienst', visible: false, key: 'shift', width: 180}] :
                [],
            {id: 'status', title: 'Status', visible: true, key: 'status', width: 100, render: (order) => {
                const {statusColor, status, subStatus} = Colors.orderStatusColor(order)

                return (
                    <div style={{width: '100%', padding: 5, textAlign: 'center', background: statusColor, borderRadius: 4}}>

                        {subStatus && subStatus !== dbCodes.status[dbCodes.status.geannuleerd()] ?
                            <P ellipsis>{`${subStatus}${Colors.orderRetourSuffix(order)}`}</P> :
                            <P ellipsis>{`${status}${Colors.orderRetourSuffix(order)}`}</P>
                        }
                    </div>
                )
            }, sort: (order) => {
                const {subStatus} = Colors.orderStatusColor(order)

                return `${order.status} ${subStatus || ''}`
            }},
            {id: 'eta', title: 'ETA', visible: false, width: 110, text: (order) => {
                const nextAddress = order.addresses.find((address) => !address?.timeOfArrival && address.estimatedTimeOfArrival)

                return nextAddress?.estimatedTimeOfArrival || ''
            }},
            {id: 'pickedUpTime', title: 'Opgehaald om', visible: false, width: 110, text: (order) => {
                const pickupAddress = order.addresses.find((address) => address.type === 'pickup')

                return pickupAddress?.timeOfArrival || ''
            }},
            {id: 'deliveredTime', title: 'Bezorgd om', visible: false, width: 110, text: (order) => {
                const deliveryAddress = order.addresses.findLast((address) => address.type === 'delivery')

                return deliveryAddress?.timeOfArrival || ''
            }},
            {
                id: 'messengerComment', title: 'Opmerking Koerier', visible: false, width: 200, text: (order) => {
                    let comment = order.addresses[order.addresses.length - 1]?.comment

                    if (!comment) {
                        const historyEntry = order.history.find((entry) => !!entry.comment && (entry.type === 'delivery' || entry.type === 'pickup') && entry.addressIndex === order.addresses.length - 1)

                        if (historyEntry) {
                            comment = historyEntry.comment
                        }
                    }

                    return comment || ''
                }
            },
            ...reseller.settings.administration.checkOrders && user.permissions.invoices ?
                [
                    {id: 'checked', title: 'Geaccordeerd', visible: false, key: 'checked', width: 120, text: (order) => {
                        return order.checked ? 'Ja' : 'Nee'
                    }}
                ] :
                [],
            ...user.permissions.invoices ?
                [
                    {id: 'invoiceDate', title: 'Factuurdatum', visible: false, key: 'invoiceDate', width: 120, text: (order) => {
                        return moment(order.invoiceDate).format('DD-MM-YYYY')
                    }, sort: (order) => order.invoiceDate},
                    {id: 'invoiced', title: 'Gefactureerd', visible: false, key: 'invoiced', width: 120, text: (order) => {
                        return order.dontInvoice ? 'n.v.t.' : order.invoiced ? 'Ja' : 'Nee'
                    }}

                ] :
                [],
            {id: 'attachments', title: 'Bijlage', visible: false, key: 'attachments', flex: 1, onClick: () => {}, render: (order) => {
                const attachments = order.addresses.flatMap((address) => address.attachments || [])
                return (
                    <P
                        onClick={() => {
                            const attachment = attachments?.[0] || {}
                            const openUrl = (file) => {
                                const raw = window.atob(file)
                                const rawLength = raw.length
                                const array = new Uint8Array(new ArrayBuffer(rawLength))

                                for (let i = 0; i < rawLength; i++) {
                                    array[i] = raw.charCodeAt(i)
                                }

                                const blob = new Blob([array], {type: attachment.type})

                                const blobUrl = URL.createObjectURL(blob)

                                window.open(blobUrl)
                            }
                            if (attachment.fileId) {
                                AddressActions.downloadAttachment(attachment.fileId, (err, file) => {
                                    if (err) {
                                        console.log(err)
                                    } else {
                                        openUrl(file)
                                    }
                                })
                            } else if (attachment.data) {
                                window.open(attachment.data)
                            }
                        }}
                        ellipsis
                    >
                        {attachments?.[0]?.fileName}{attachments.length > 1 ? ` (+${attachments.length - 1})` : ''}
                    </P>
                )
            }},
            {id: 'view', visible: true, width: 50, showOnHover: true, render: (order) => {
                return (
                    <IconButton onClick={() => this.viewOrderModal.open(order._id)}>
                        <i className='mdi mdi-eye' />
                    </IconButton>
                )
            }}
        ]
    }

    onClickEditTemplate(template) {
        this.editOrderModal.open(template, true)
    }

    onChangeDates(orderStartDate, orderEndDate) {
        OrderActions.setDates(orderStartDate, orderEndDate)
    }

    onChangeTimes(startTime, endTime, startInclude, endInclude) {
        OrderActions.setTimes(startTime, endTime, startInclude, endInclude)
    }

    onChangeQueries(orderQueries) {
        if (this.table) {
            this.table.selectPage(1)
        }
        OrderActions.setQueries(orderQueries)
    }

    onChangeTable(selectedOrders) {
        OrderActions.setSelected(selectedOrders)
    }

    onClickNew() {
        this.editOrderModal.open()
        OrderActions.setSelected([])
    }

    onClickImport() {
        this.importModal.open()
        OrderActions.setSelected([])
    }

    onClickScan() {
        this.scanModal.open()
    }

    async onClickExport(template, onProgress) {
        const {orders, selectedOrders, orderStartDate, orderEndDate, customers, routes} = this.state
        const {reseller, vehicles} = this.props
        const exportOrders = []
        const ordersById = _.keyBy(orders, '_id')

        selectedOrders.map((id) => {
            const order = ordersById[id]

            if (order) {
                order.routeName = this.state.routes[order.routeId]?.name || ''
                order.messengerName = this.state.routes[order.routeId]?.messengerName || ''
                order.vehicleType = this.state.routes[order.routeId]?.vehicleType || ''

                exportOrders.push(order)
            }
        })

        await csvExport.orders(reseller, exportOrders, orderStartDate, orderEndDate, customers, routes, vehicles, template, onProgress)
        OrderActions.setSelected([])
        this.setState({exportOrdersIsOpen: false})
    }

    getDefaultTemplateRrule(date) {
        return new RRule({
            freq: RRule.WEEKLY,
            interval: 1,
            byweekday: [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR],
            dtstart: moment(date).hour(12).toDate()
        }).toString()
    }

    createTemplateFromOrder(order, startDate, rrule, endDate) {
        const {customers} = this.state
        const {reseller} = this.props

        order = JSON.parse(JSON.stringify(order))

        const template = NewOrder(reseller, {selectedDate: startDate})

        const customer = customers[order.customer]

        template.name = customer ? `${customer.name} - ${order.addresses[0]?.name}${order.addresses.length > 1 ? ` +${order.addresses.length - 1}` : ''}` : order.reference || order.trackTrace || ''
        template.rrule = rrule
        template.endDate = endDate || undefined

        template.customer = order.customer
        template.contact = order.contact || ''
        template.email = order.email || ''
        template.phone = order.phone || ''

        template.addresses = []
        order.addresses.map((address) => {
            const newAddress = {
                type: address.type,
                name: address.name,
                attention: address.attention,
                street: address.street,
                nr: address.nr,
                addition: address.addition,
                street2: address.street2,
                postalCode: address.postalCode,
                city: address.city,
                country: address.country,
                email: address.email || '',
                phone: address.phone || '',
                instructions: address.instructions,
                startTime: address.startTime,
                endTime: address.endTime,
                isBusiness: address.isBusiness || false,

                gpsRequired: !!address.gpsRequired,
                signatureRequired: !!address.signatureRequired,
                nameRequired: !!address.nameRequired,
                signatureNeighbors: !!address.signatureNeighbors,
                scanRequired: !!address.scanRequired,
                imageRequired: !!address.imageRequired,
                statedAddressOnly: !!address.statedAddressOnly,
                mailboxDelivery: !!address.mailboxDelivery,
                refrigerated: !!address.refrigerated,
                idCheck: !!address.idCheck,
                minimumAge: address.minimumAge ?? undefined,
                customOptions: address.customOptions || [],
                attachments: address.attachments || []
            }

            if (address.position) {
                newAddress.position = JSON.parse(JSON.stringify(address.position))
            }

            template.addresses.push(newAddress)
        })

        if (order.colli) {
            template.colli = []

            order.colli.map((collo) => {
                if (collo.barcode) {
                    template.colli.push({
                        type: collo.type,
                        description: collo.description,
                        weight: collo.weight,
                        length: collo.length,
                        width: collo.width,
                        height: collo.height,
                        barcode: 'Barcode'
                    })
                }
            })
        }

        template.distance = order.distance || 0
        template.priceTableId = order.priceTableId || ''
        template.price = order.price
        template.reference = order.reference
        template.notes = order.notes
        template.autoRetour = !!order.autoRetour
        template.nrOfDeliveries = order.nrOfDeliveries
        template.nrOfDaysBeforeRetour = order.nrOfDaysBeforeRetour

        if (order.retourAddress) {
            template.retourAddress = {
                instructions: '',
                startTime: '00:00',
                endTime: '23:59',
                ...order.retourAddress
            }
        }

        template.allowAddCollo = order.allowAddCollo || 'yes'

        return template
    }

    onClickCreateTemplate() {
        const {orders, selectedOrders, orderStartDate} = this.state

        if (!selectedOrders.length) {
            return
        }

        if (selectedOrders.length === 1) {
            const order = _.find(orders, (order) => order._id === selectedOrders[0])

            if (!order) {
                this.popup.setError('Rit niet gevonden.')
                return
            }

            const startDate = moment(order.date).add(1, 'days').format('YYYY-MM-DD')
            const template = this.createTemplateFromOrder(order, startDate, this.getDefaultTemplateRrule(startDate))

            this.editOrderModal.open(template, true)
            OrderActions.setSelected([])

            return
        }

        const startDate = moment(orderStartDate).isAfter(moment()) ? orderStartDate : time.today()
        this.createTemplatesPopup.open(selectedOrders, startDate)
    }

    async onConfirmCreateTemplates({selectedOrderIds, startDate, endDate, rrule}) {
        const {orders} = this.state

        let success = 0
        const errors = []

        for (const orderId of selectedOrderIds) {
            const order = _.find(orders, (order) => order._id === orderId)

            if (!order) {
                errors.push(`Rit niet gevonden (${orderId}).`)
                continue
            }

            const template = this.createTemplateFromOrder(order, startDate, rrule, endDate)

            await new Promise((resolve) => {
                OrderActions.create(template, (err) => {
                    if (err) {
                        errors.push(`${order.trackTrace || orderId}: ${err}`)
                    } else {
                        success += 1
                    }

                    resolve()
                })
            })
        }

        OrderActions.setSelected([])

        if (errors.length) {
            this.popup.open('Rit templates aangemaakt', `${success} ${success === 1 ? 'rit template' : 'rit templates'} aangemaakt. ${errors.length} mislukt.`)
            this.popup.setErrors(errors)
        } else {
            this.popup.open('Rit templates aangemaakt')
            this.popup.setMessage(`${success} ${success === 1 ? 'rit template is' : 'rit templates zijn'} aangemaakt.`)
        }
    }

    async onClickCopy(id) {
        const {reseller} = this.props
        const {orders, selectedOrders, customers, orderStartDate} = this.state
        id = id || selectedOrders[0]
        let order = _.find(orders, (order) => order._id === id)
        if (!order) {
            order = await new Promise((resolve) => {
                OrderActions.getOne(id, (err, order) => {
                    if (!err) {
                        resolve(order)
                        return
                    }

                    this.popup.setError(err)
                })
            })
        }
        order = JSON.parse(JSON.stringify(order))

        const newOrder = NewOrder(reseller, {selectedDate: orderStartDate})

        const customer = customers[order.customer]

        if (customer) {
            newOrder.customer = order.customer
            newOrder.contact = order.contact
            newOrder.email = order.email
            newOrder.phone = order.phone
        }

        newOrder.addresses = []
        // A retour is copied as the original order, not as an order to the retour address
        getOriginalOrderAddresses(order).map((address) => {
            const newAddress = {
                type: address.type,
                name: address.name,
                attention: address.attention,
                street: address.street,
                nr: address.nr,
                addition: address.addition,
                street2: address.street2,
                postalCode: address.postalCode,
                city: address.city,
                country: address.country,
                email: address.email || '',
                phone: address.phone || '',
                instructions: address.instructions,
                startTime: address.startTime,
                endTime: address.endTime,
                isBusiness: address.isBusiness || false,

                gpsRequired: !!address.gpsRequired,
                signatureRequired: !!address.signatureRequired,
                nameRequired: !!address.nameRequired,
                signatureNeighbors: !!address.signatureNeighbors,
                scanRequired: !!address.scanRequired,
                imageRequired: !!address.imageRequired,
                statedAddressOnly: !!address.statedAddressOnly,
                mailboxDelivery: !!address.mailboxDelivery,
                refrigerated: !!address.refrigerated,
                idCheck: !!address.idCheck,
                minimumAge: address.minimumAge ?? undefined,
                customOptions: address.customOptions || [],
                attachments: address.attachments || []
            }

            if (address.position) {
                newAddress.position = JSON.parse(JSON.stringify(address.position))
            }

            newOrder.addresses.push(newAddress)
        })

        if (order.colli) {
            const {colli, trackTrace} = copyColli(order.colli, order)

            newOrder.colli = colli

            if (trackTrace) {
                newOrder.trackTrace = trackTrace
            }
        }

        newOrder.distance = order.distance || 0
        newOrder.priceTableId = order.priceTableId || ''
        newOrder.price = order.price
        newOrder.reference = order.reference
        newOrder.notes = order.notes
        newOrder.autoRetour = !!order.autoRetour
        newOrder.nrOfDeliveries = order.nrOfDeliveries
        newOrder.nrOfDaysBeforeRetour = order.nrOfDaysBeforeRetour

        if (order.retourAddress) {
            newOrder.retourAddress = order.retourAddress
            newOrder.retourAddress = {
                instructions: '',
                startTime: '00:00',
                endTime: '23:59',
                ...order.retourAddress
            }
        }

        newOrder.allowAddCollo = order.allowAddCollo || 'yes'

        this.editOrderModal.open(newOrder)
        OrderActions.setSelected([])
    }

    onClickCheck() {
        const {selectedOrders} = this.state

        this.popup.open('Ritten accorderen', 'Ritten worden geaccordeerd, hierna zijn ze zichtbaar op de factuur.', () => {
            OrderActions.setSelected([])

            let success = 0
            const errors = []

            this.popup.setProgress(0, selectedOrders.length)

            aSync.eachSeries(selectedOrders, (id, next) => {
                OrderActions.check(id, (err) => {
                    if (err) {
                        errors.push(err)
                    } else {
                        success += 1
                    }

                    this.popup.setProgress(success + errors.length, selectedOrders.length)

                    next()
                })
            }).then(() => {
                if (errors.length) {
                    this.popup.setMessage(`${success} ${success === 1 ? 'rit' : 'ritten'} geaccordeerd.`)
                    this.popup.setErrors(errors)
                } else {
                    this.popup.close()
                }
            })
        })
    }

    async onClickCalculatePrice() {
        const {selectedOrders} = this.state
        const {reseller} = this.props
        let cancelled = false
        let inProgress = false

        this.popup.setInputs([
            {
                type: 'radio',
                name: 'pricingOption',
                label: 'Herbereken prijs volgens tarieftabel',
                optionValue: 'recalculatePrice',
                value: '',
                row: 'recalculatePrice',
                style: {width: '100%'}
            },
            {
                type: 'select',
                name: 'priceTable',
                label: 'Tarieftabel',
                value: '',
                allowEmpty: true,
                placeholder: 'Behoud huidige tarieftabel',
                options: reseller.settings.orders.prices.map((orderPriceTable) => ({value: orderPriceTable.id, title: orderPriceTable.name})),
                disabled: (values) => values.pricingOption !== 'recalculatePrice',
                row: 'recalculatePrice',
                style: {width: '45%'}
            },
            {
                type: 'radio',
                name: 'pricingOption',
                label: 'Wijzig prijs',
                optionValue: 'newPrice',
                value: '',
                row: 'newPrice',
                style: {width: '100%'}
            },
            {
                type: 'currency',
                name: 'newPrice',
                label: 'Prijs',
                value: '',
                disabled: (values) => values.pricingOption !== 'newPrice',
                row: 'newPrice',
                style: {width: '45%'}
            },
            {
                type: 'checkbox',
                name: 'invoiceOption',
                label: 'Wijzig facturatie van ritten',
                value: false,
                row: 'invoice',
                style: {width: '100%'}
            },
            {
                type: 'select',
                name: 'invoice',
                label: 'Factureren',
                value: '',
                options: [{value: 'on', title: 'Aan'}, {value: 'off', title: 'Uit'}],
                disabled: (values) => !values.invoiceOption,
                row: 'invoice',
                style: {width: '45%'}
            }
        ])

        // The popup generates its own batchId (returned alongside the confirmed inputs below) and tracks
        // `updateProgress-${batchId}` updates for it internally, so the progress bar fills in as it goes.
        const values = await this.popup.open('Wijzig rit prijs', undefined, undefined, () => {
            // Only the backend actually running the batch needs cancelling - closing before it started, or
            // once it already finished, has no in-flight request to wait for.
            if (!inProgress) {
                return
            }

            cancelled = true

            // Wait for the backend to acknowledge the cancellation before the popup actually closes, so the
            // batch response below can no longer reopen it once it's gone.
            return new Promise((resolve) => {
                socket.emit(`cancelCalculatingPrice-${batchId}`, resolve)
            })
        }, false, true)
        if (!values) return

        const {pricingOption, priceTable, newPrice, invoiceOption, invoice, batchId} = values

        OrderActions.setSelected([])
        inProgress = true

        try {
            // Recalculated in a single batched backend call instead of one request per order.
            const {data: success = 0, errors = []} = await emit('orders.calculatePrice', {ids: selectedOrders, batchId, pricingOption, newPrice, invoice: invoiceOption ? invoice : '', priceTable})

            if (cancelled) {
                return
            }

            this.popup.setMessage(`${success} ${success === 1 ? 'rit' : 'ritten'} herberekend.`)
            this.popup.setErrors(errors)
        } catch (err) {
            if (cancelled) {
                return
            }

            this.popup.setError(err.message || err)
        } finally {
            inProgress = false
        }
    }

    async onClickAddOptions() {
        const {selectedOrders} = this.state
        const {reseller} = this.props

        this.popup.setInputs([
            {
                label: 'Opties',
                name: 'options',
                values: [],
                type: 'select',
                options: [
                    ...Object.entries(dbCodes.pickupAndDeliveryOptions).map(([key, value]) => ({
                        value: key,
                        title: value
                    })),
                    ...(reseller.settings.orders.customOptions || []).map((option) => ({
                        value: option.id,
                        title: option.name,
                        icon: 'mdi mdi-circle',
                        iconColor: option.color,
                        showIconInValue: true
                    }))
                ]
            },
            {
                label: 'Opties vervangen',
                name: 'replace',
                value: false,
                type: 'checkbox'
            }
        ])

        const values = await this.popup.open('Opties toevoegen', 'Kies de opties die toegevoegd moeten worden.')
        if (!values) return

        OrderActions.setSelected([])

        const options = values.options
        const replace = !!values.replace

        let success = 0
        const errors = []

        this.popup.setProgress(0, selectedOrders.length)

        for (const orderId of selectedOrders) {
            await new Promise((resolve) => {
                OrderActions.addOptions(orderId, options, replace, (err) => {
                    if (err) {
                        errors.push(err)
                    } else {
                        success += 1
                    }

                    this.popup.setProgress(success + errors.length, selectedOrders.length)

                    resolve()
                })
            })
        }

        this.popup.setMessage(`${success} ${success === 1 ? 'rit' : 'ritten'} bewerkt.`)
        this.popup.setErrors(errors)
    }

    async onClickAssignBranch() {
        const {selectedOrders} = this.state
        const {reseller} = this.props

        const availableBranches = getAvailableBranches(reseller)

        this.popup.setInputs([
            {label: t('branch'), name: 'branchId', value: '', type: 'select', options: [{value: '', title: t('noBranch')}, ...availableBranches.map((branch) => ({value: branch.id, title: branch.name}))]}
        ])

        const values = await this.popup.open(t('assignBranch'), t('chooseBranchForOrders'))
        if (!values) return

        OrderActions.setSelected([])

        const branchId = values.branchId || ''

        let success = 0
        const errors = []

        this.popup.setProgress(0, selectedOrders.length)

        for (const orderId of selectedOrders) {
            await new Promise((resolve) => {
                OrderActions.editBranch(orderId, branchId, (err) => {
                    if (err) {
                        errors.push(err)
                    } else {
                        success += 1
                    }

                    this.popup.setProgress(success + errors.length, selectedOrders.length)

                    resolve()
                })
            })
        }

        this.popup.setMessage(`${success} ${success === 1 ? 'rit' : 'ritten'} bewerkt.`)
        this.popup.setErrors(errors)
    }

    onClickRemove(order) {
        if (order) {
            // if (order.rrule) {
            //     this.prompt.open('Verwijder herhaalde rit', '', [
            //         {title: 'Alleen deze rit', value: 'remove', default: true},
            //         {title: 'Deze en toekomstige ritten', value: 'removeAll'}
            //     ], (choice) => {
            //         this.setState({loading: true, error: ''})

            //         if (choice === 'removeAll') {
            //             OrderActions.removeTemplate(order, (err) => {
            //                 if (err) {
            //                     this.prompt.setError(err)
            //                 } else {
            //                     this.prompt.close()
            //                     this.viewOrderModal.close()
            //                 }
            //             })
            //         } else {
            //             OrderActions.remove([order._id], (err) => {
            //                 if (err) {
            //                     this.prompt.setError(err)
            //                 } else {
            //                     this.prompt.close()
            //                     this.viewOrderModal.close()
            //                 }
            //             })
            //         }
            //     })
            // } else {
            // }
            this.popup.open('Verwijder rit', 'Weet je zeker dat je deze rit wilt verwijderen?', () => {
                OrderActions.remove([order._id], (err) => {
                    if (err) {
                        this.popup.setError(err)
                    } else {
                        this.popup.close()
                        this.viewOrderModal.close()
                    }
                })
            })
        } else {
            const {selectedOrders} = this.state

            this.popup.open('Ritten verwijderen', 'Ritten worden definitief verwijderd.', () => {
                OrderActions.setSelected([])

                OrderActions.remove(selectedOrders, (err, errors, success) => {
                    if (err) {
                        this.popup.setError(err)
                    } else if (errors.length) {
                        this.popup.setMessage(`${success} ${success === 1 ? 'rit' : 'ritten'} verwijderd.`)
                        this.popup.setErrors(errors)
                    } else {
                        this.popup.close()
                    }
                })
            })
        }
    }

    onClickRecalculateDeliveryZoneIds() {
        const {selectedOrders} = this.state

        this.popup.open(t('recalculateDeliveryZoneIds'), t('recalculateDeliveryZoneIdsText'), () => {
            OrderActions.recalculateDeliveryZoneIds(selectedOrders, (err, errors, success) => {
                if (err) {
                    this.popup.setError(err)
                } else if (errors.length) {
                    this.popup.setMessage(`${success} ${success === 1 ? 'rit' : 'ritten'} herberekend.`)
                    this.popup.setErrors(errors)
                } else {
                    this.popup.close()
                }
            })
        })
    }

    async onClickPrintLabels(id, addressIndex, colloIndex) {
        const {selectedOrders, printerPageSize} = this.state

        const ids = id ? [id] : selectedOrders

        printLabels({
            ids,
            printerPageSize,
            printPopup: this.printPopup,
            pdfModal: this.pdfModal,
            print: (ids, nrOfEmptyLabels) => fromLabelCallback((callback) => OrderActions.printLabels(ids, nrOfEmptyLabels, addressIndex, colloIndex, callback)),
            itemName: 'ritten',
            onPrint: () => OrderActions.setSelected([])
        })
    }

    onChangePrinterPageSize(event) {
        localStorage.printerPageSize = event.target.value
        this.setState({printerPageSize: event.target.value})
    }

    async onChangeRoute(id, event, callback) {
        const {orders, routes, selectedOrders} = this.state
        let routeId = event.target.value
        let userId
        let newRoute = false

        if (routeId.indexOf('new|') > -1) {
            userId = routeId.split('|')[1]
            routeId = ''
            newRoute = true
        }

        const ids = id ? [id] : selectedOrders

        if (!id) {
            OrderActions.setSelected([])
        }

        const route = routes[routeId]

        let bool

        if (route?.started) {
            bool = await this.popup.open('Route wijzigen', 'Stop die worden toegevoegd aan een gestarte route worden automatisch op onderweg gezet.')
        } else if (route?.ready) {
            bool = await this.popup.open('Route wijzigen', 'Je voegt adressen toe aan een route die gereed is. De route wordt teruggezet naar concept.')
        } else {
            const ordersInReadyRoute = _.some(ids, (id) => orders[id]?.routeId && routes[orders[id].routeId]?.ready)

            if (ordersInReadyRoute) {
                bool = await this.popup.open('Route wijzigen', 'Je verwijderd adressen uit een route die gereed is. Weet je dit zeker?')
            } else {
                const ordersInStartedRoute = _.some(ids, (id) => orders[id]?.routeId && routes[orders[id].routeId]?.started)

                if (ordersInStartedRoute) {
                    bool = await this.popup.open('Route wijzigen', 'Je verwijderd adressen uit een route die onderweg is. Weet je dit zeker?')
                } else {
                    bool = true
                }
            }
        }

        if (bool) {
            OrderActions.addToRoute({ids, routeId, userId}, (err, route, order, errors) => {
                if (err) {
                    this.popup.setError(err)
                } else {
                    if (errors.length) {
                        this.popup.setErrors(errors)
                    } else {
                        this.popup.close()
                    }

                    if (newRoute && route) {
                        this.editRouteModal.open(route)
                    }
                }

                typeof callback === 'function' && callback(err, order)
            })
        }
    }

    async sendToPartner(ids) {
        const {reseller} = this.props
        const {partners, orders} = this.state

        // Without the network module orders can not be forwarded, only taken back
        if (!reseller.permissions.network) {
            if (!await this.popup.open(t('partnerTakeBackTo', reseller.settings.accountName || reseller.name), t('partnerTakeBackWithoutNetwork'))) return
            await this.forwardOrders(ids.filter((id) => orders[id]?.handledBy === 'partner'), [reseller._id])
            return
        }

        // Only partners this reseller forwards orders to, taking orders back to the own account is a separate button
        const carriers = Object.values(partners || {})
            .filter((partner) => reseller.settings.outgoingPartners?.some((connection) => connection._id === partner._id && connection.status === 'active'))
            .map((partner) => ({value: partner._id, title: partner.name, img: partner.logo}))

        this.popup.setInputs([{
            type: 'select',
            name: 'carrierIds',
            label: t('partnerCarriers'),
            noSort: true,
            selectAll: true,
            values: [],
            options: carriers
        }])

        if (ids.some((id) => orders[id]?.handledBy === 'partner')) {
            await this.popup.setButtonTop({
                label: t('partnerTakeBackTo', reseller.settings.accountName || reseller.name),
                icon: 'mdi mdi-undo',
                onClick: () => this.forwardOrders(ids, [reseller._id])
            })
        }

        const values = await this.popup.open(t('partnerSendToPartner'), t('partnerSendToPartnerText'))
        if (!values) return

        const {carrierIds = []} = values

        if (!carrierIds.length) {
            this.popup.setError(t('partnerSelectCarrier'))
            return
        }

        await this.forwardOrders(ids, carrierIds)
    }

    /**
     * Forwards the orders to the first of `carrierIds` that can carry them out, the own reseller's id takes them back.
     */
    async forwardOrders(ids, carrierIds) {
        OrderActions.setSelected([])

        const errors = []

        for (const id of ids) {
            await new Promise((resolve) => {
                OrderActions.sendToPartner(id, carrierIds, (err) => {
                    if (err) {
                        errors.push(err)
                    }
                    resolve()
                })
            })
        }

        if (errors.length) {
            this.popup.setErrors(errors)
        } else {
            this.popup.close()
        }
    }

    onClickCreatePlanning() {
        const {selectedOrders, orders} = this.state

        const multiOrders = selectedOrders.map((id) => orders[id]).filter((order) => order?.addresses.length > 1)

        if (multiOrders.length > 0) {
            // A string, the error splits it into lines in the font of the popup
            const lines = [t('createPlanningMultiStopOrders'), ...multiOrders.map((order) => `- ${t('order')} ${order.trackTrace}`)]

            this.popup.open(t('createPlanningNotPossible'))
            this.popup.setError(lines.join('\n'))
            return
        }

        this.createPlanningPopup.open(selectedOrders, (options) => {
            OrderActions.setSelected([])

            OrderActions.createPlanning(selectedOrders, options, (err) => {
                if (err) {
                    this.createPlanningPopup.setError(err || t('createPlanningNoRouteFound'))
                } else {
                    this.createPlanningPopup.close()
                }
            })
        })
    }

    onClickOpenTimeslotPopup() {
        const {selectedOrders} = this.state

        this.changeTimeslotPopup.open(selectedOrders)
    }

    onClickCancelRetour(id) {
        this.popup.open(t('cancelRetour'), t('cancelRetourConfirm'), () => {
            OrderActions.cancelRetour(id, '', (err, order) => {
                if (err) {
                    this.popup.setError(err)
                } else {
                    order && this.setState({order})
                    this.popup.close()
                }
            })
        })
    }

    render() {
        const {view, ordersSubView, filteredOrders, orders, selectedOrders, routes, routeTemplates, usersObject, customers, carriers, partners, ordersLoading, addressBook, orderStartDate, orderEndDate, startTime, endTime, startInclude, endInclude, orderQueries, printerPageSize, exportOrdersIsOpen, error} = this.state
        const {reseller, user, history, onUpdateReseller, selectedBranchIds} = this.props

        return (
            <Stack style={{flex: 1}}>
                {error && <Alert style={{marginBottom: 6}} variant='error' onClose={() => OrderActions.clearError()}>{error}</Alert>}

                {view === 'orders' && (
                    <div style={{borderBottom: `1px solid ${Colors.border}`}}>
                        <Tabs style={{width: 400, marginBottom: 2}} value={ordersSubView} onChange={(event) => {this.setState({ordersSubView: event.target.value})}}>
                            <Tab style={{fontSize: 14, marginLeft: 16}} size='sm' value='orders'>
                                Ritten
                            </Tab>
                            <Tab style={{fontSize: 14}} size='sm' value='orderTemplates'>
                                Rit templates
                            </Tab>
                        </Tabs>
                    </div>
                )}

                {!(view === 'orders' && ordersSubView === 'orderTemplates') && (
                    <Panel style={{display: 'flex', borderTop: 'none', borderLeft: 'none', borderRight: 'none', background: Colors.backgroundNeutral, padding: '20px 10px 10px 10px'}}>
                        <SearchBar
                            columns={this.columns().filter((column) => !!column.title)}
                            onQueryChange={this.onChangeQueries.bind(this)}
                            onDateChange={this.onChangeDates.bind(this)}
                            onTimeChange={this.onChangeTimes.bind(this)}
                            startDate={orderStartDate}
                            endDate={orderEndDate}
                            startTime={startTime}
                            endTime={endTime}
                            startInclude={startInclude}
                            endInclude={endInclude}
                            queries={orderQueries}
                            user={user}
                            dateRange={view === 'orders'}
                        />

                        <Row style={{flexWrap: 'wrap', columnGap: formSpacing.columnGap}}>
                            <Row style={{paddingLeft: 6, paddingRight: 6, flex: 0, columnGap: formSpacing.columnGap, marginBottom: 6, minWidth: 'auto'}}>
                                <Button
                                    style={{minWidth: 115}}
                                    variant='outline-white'
                                    label='Nieuwe rit'
                                    onClick={this.onClickNew.bind(this)}
                                />

                                <Button
                                    variant='outline-white'
                                    onClick={this.onClickImport.bind(this)}
                                    tooltip='Ritten importeren'
                                >
                                    <i className='mdi mdi-file-import' />
                                </Button>

                                <Button
                                    variant='outline-white'
                                    onClick={this.onClickScan.bind(this)}
                                    tooltip='Scannen'
                                >
                                    <i className='mdi mdi-barcode-scan' />
                                </Button>
                            </Row>

                            {selectedOrders.length > 0 &&
                                <>
                                    <Row style={{paddingLeft: 6, paddingRight: 6, flex: 0, columnGap: formSpacing.columnGap, height: 36, marginBottom: 6, minWidth: 'auto'}}>
                                        <Button
                                            variant='outline-white'
                                            onClick={() => this.setState({exportOrdersIsOpen: true})}
                                            tooltip='Ritten exporteren'
                                            disabled={reseller.name === 'MSG demo'}
                                        >
                                            <i className='mdi mdi-file-export' />
                                        </Button>

                                        <Button
                                            variant='outline-white'
                                            onClick={this.onClickCreateTemplate.bind(this)}
                                            tooltip={selectedOrders.length === 1 ? 'Rit template maken' : 'Rit templates maken'}
                                        >
                                            <i className='mdi mdi-calendar-refresh' />
                                        </Button>

                                        {selectedOrders.length === 1 &&
                                            <Button
                                                variant='outline-white'
                                                onClick={() => this.onClickCopy()}
                                                tooltip='Rit kopiëren'
                                            >
                                                <i className='mdi mdi-content-copy' />
                                            </Button>
                                        }

                                        <SplitButton
                                            variant='outline-white'
                                            value={printerPageSize}
                                            options={[
                                                {title: 'Papierformaat A6', value: 'A6'},
                                                {title: 'Papierformaat 10x21', value: '10x21'},
                                                {title: 'Papierformaat A5', value: 'A5'},
                                                {title: 'Papierformaat A4 | 4x A6', value: 'A4'},
                                                {title: 'Papierformaat A4 | 3x 10x21', value: 'A410x21'},
                                                {title: 'Papierformaat A4 | 2x A5', value: 'A4A5'}
                                            ]}
                                            onChange={this.onChangePrinterPageSize.bind(this)}
                                            onClick={() => this.onClickPrintLabels()}
                                            tooltip='Labels printen'
                                        >
                                            <i className='mdi mdi-printer' />
                                        </SplitButton>

                                        <Button
                                            variant='outline-white'
                                            onClick={this.onClickCalculatePrice.bind(this)}
                                            tooltip='Prijs aanpassen'
                                        >
                                            <i className='mdi mdi-currency-eur' />
                                        </Button>

                                        <Button
                                            variant='outline-white'
                                            onClick={this.onClickAddOptions.bind(this)}
                                            tooltip='Opties toevoegen'
                                        >
                                            <i className='mdi mdi-package-variant-closed' />
                                        </Button>

                                        <Button
                                            variant='outline-white'
                                            onClick={this.onClickOpenTimeslotPopup.bind(this)}
                                            tooltip='Tijdvak wijzigen'
                                        >
                                            <i className='mdi mdi-clock-edit-outline' />
                                        </Button>

                                        <Button
                                            variant='outline-white'
                                            onClick={() => this.onClickRecalculateDeliveryZoneIds()}
                                            tooltip={t('recalculateDeliveryZoneIds')}
                                        >
                                            <i className='mdi mdi-map-marker-radius' />
                                        </Button>

                                        {getAvailableBranches(reseller).length > 0 &&
                                            <Button
                                                variant='outline-white'
                                                onClick={this.onClickAssignBranch.bind(this)}
                                                tooltip={t('assignBranch')}
                                            >
                                                <i className='mdi mdi-office-building-marker-outline' />
                                            </Button>
                                        }

                                        <Button
                                            variant='outline-white'
                                            onClick={() => this.onClickRemove()}
                                            tooltip='Ritten verwijderen'
                                        >
                                            <i className='mdi mdi-delete' />
                                        </Button>

                                        {reseller.settings.administration.checkOrders && user.permissions.invoices && view === 'orders' &&
                                            <Button
                                                variant='outline-white'
                                                onClick={this.onClickCheck.bind(this)}
                                                tooltip='Ritten accorderen'
                                            >
                                                <i className='mdi mdi-check' />
                                            </Button>
                                        }

                                        {reseller.accountType === 'carrierPlus' && selectedOrders.length > 2 &&
                                            <Button
                                                variant='outline-white'
                                                onClick={this.onClickCreatePlanning.bind(this)}
                                                tooltip='Automatisch routes berekenen'
                                            >
                                                <i className='mdi mdi-transit-connection-variant' />
                                            </Button>
                                        }

                                        <SelectRoute
                                            style={{width: 160, marginLeft: 6}}
                                            variant='outline-white'
                                            label='Route wijzigen'
                                            usersObject={usersObject}
                                            routes={routes}
                                            onChange={(event) => this.onChangeRoute(null, event)}
                                        />

                                    </Row>

                                    <Row style={{paddingLeft: 6, paddingRight: 6, flex: 0, columnGap: formSpacing.columnGap, height: 36, marginBottom: 6, minWidth: 'auto'}}>
                                        <Button
                                            variant='outline-white'
                                            tooltip='Aangeleverd op hub'
                                            icon='mdi mdi-package-variant-closed-check'
                                            onClick={() => {
                                                if (selectedOrders.length === 1) {
                                                    const order = _.find(orders, (order) => order._id === selectedOrders[0])

                                                    if (order) {
                                                        this.atHubOrderPopup.open(order)
                                                    }
                                                } else {
                                                    this.atHubOrderPopup.open(selectedOrders)
                                                }
                                            }}
                                        />

                                        <Button
                                            variant='outline-white'
                                            tooltip='Herplannen'
                                            icon='mdi mdi-calendar'
                                            onClick={() => {
                                                if (selectedOrders.length === 1) {
                                                    const order = _.find(orders, (order) => order._id === selectedOrders[0])

                                                    if (order) {
                                                        this.rescheduleOrderPopup.open(order)
                                                    }
                                                } else {
                                                    this.rescheduleOrderPopup.open(selectedOrders)
                                                }
                                            }}
                                        />

                                        {!reseller.isShop &&
                                            <Button
                                                variant='outline-white'
                                                tooltip='In bewaring'
                                                icon='mdi mdi-archive'
                                                onClick={() => this.onHoldOrderPopup.open(selectedOrders)}
                                            />
                                        }

                                        {!reseller.isShop &&
                                            <Button
                                                variant='outline-white'
                                                tooltip='Retour'
                                                icon='mdi mdi-keyboard-return'
                                                onClick={() => this.returnOrderPopup.open(selectedOrders)}
                                            />
                                        }

                                        <MenuButton
                                            variant='outline-white'
                                            icon='mdi mdi-close-circle'
                                            options={[
                                                {label: 'Niet aangeleverd', onClick: () => {
                                                    if (selectedOrders.length === 1) {
                                                        const order = _.find(orders, (order) => order._id === selectedOrders[0])

                                                        if (order) {
                                                            this.notSuppliedOrderPopup.open(order)
                                                        }
                                                    } else {
                                                        this.notSuppliedOrderPopup.open(selectedOrders)
                                                    }
                                                }},
                                                {label: 'Manco', onClick: () => {
                                                    if (selectedOrders.length === 1) {
                                                        const order = _.find(orders, (order) => order._id === selectedOrders[0])

                                                        if (order) {
                                                            this.mancoOrderPopup.open(order)
                                                        }
                                                    } else {
                                                        this.mancoOrderPopup.open(selectedOrders)
                                                    }
                                                }},
                                                {label: 'Annuleren', onClick: () => {
                                                    if (selectedOrders.length === 1) {
                                                        const order = _.find(orders, (order) => order._id === selectedOrders[0])

                                                        if (order?.type === 'retour') {
                                                            this.onClickCancelRetour(order._id)
                                                        } else if (order) {
                                                            this.cancelOrderPopup.open(order)
                                                        }
                                                    } else {
                                                        this.cancelOrderPopup.open(selectedOrders)
                                                    }
                                                }}
                                            ]}
                                        />

                                        <Button
                                            variant='outline-white'
                                            label='Ophalen / Bezorgen'
                                            style={{minWidth: 155}}
                                            onClick={() => {
                                                if (selectedOrders.length === 1) {
                                                    const order = _.find(orders, (order) => order._id === selectedOrders[0])

                                                    if (order) {
                                                        this.pickupDeliverPopup.open(order, reseller, customers[order.customer])
                                                    }
                                                } else {
                                                    this.completeOrderPopup.open(selectedOrders)
                                                }
                                            }}
                                        />

                                        {/* Forwarding needs the network module, taking forwarded orders back is always possible */}
                                        {((reseller.permissions.network && Object.keys(partners || {}).length > 0) || selectedOrders.some((id) => orders[id]?.handledBy === 'partner')) &&
                                            <Button
                                                variant='outline-white'
                                                icon='mdi mdi-truck-fast'
                                                onClick={() => this.sendToPartner(selectedOrders)}
                                            />
                                        }
                                    </Row>
                                </>
                            }
                        </Row>
                    </Panel>
                )}

                {view === 'orders' && ordersSubView === 'orders' &&
                    <div style={{flex: 1, marginTop: 24, marginLeft: 24, marginRight: 24}}>
                        <Table
                            tableName='dashboard'
                            columns={this.columns()}
                            rows={Object.values(filteredOrders)}
                            selectedRows={selectedOrders}
                            loading={ordersLoading}
                            onChange={this.onChangeTable.bind(this)}
                            ref={(ref) => this.table = ref}
                        />
                    </div>
                }

                {view === 'orders' && ordersSubView === 'orderTemplates' && (
                    <OrderTemplates
                        reseller={reseller}
                        customers={customers}
                        onNewTemplateClick={() => {
                            this.editOrderModal.open(undefined, true, () => {
                                const templateOrder = {...this.editOrderModal.state.order}

                                templateOrder.rrule = this.editOrderModal.recurrence.init()
                                templateOrder.date = time.today()
                                templateOrder.endDate = undefined
                                this.editOrderModal.setState({order: templateOrder})
                            })
                        }}
                        onEditTemplateClick={this.onClickEditTemplate}
                        onCopyTemplateClick={(template) => {
                            template = JSON.parse(JSON.stringify(template))

                            const startDate = moment(template.startDate || template.date).isAfter(moment()) ? moment(template.startDate || template.date).format('YYYY-MM-DD') : time.today()

                            const newTemplate = NewOrder(reseller, {selectedDate: startDate})

                            newTemplate.name = template.name
                            newTemplate.rrule = template.rrule

                            if (template.endDate && moment(template.endDate).isBefore(moment(newTemplate.date))) {
                                newTemplate.endDate = undefined
                            } else {
                                newTemplate.endDate = template.endDate
                            }

                            const customer = customers[template.customer]

                            if (customer) {
                                newTemplate.customer = template.customer
                                newTemplate.contact = template.contact
                                newTemplate.email = template.email
                                newTemplate.phone = template.phone
                            }

                            newTemplate.addresses = []
                            template.addresses.forEach((address) => {
                                const newAddress = {
                                    type: address.type,
                                    name: address.name,
                                    attention: address.attention,
                                    street: address.street,
                                    nr: address.nr,
                                    addition: address.addition,
                                    street2: address.street2,
                                    postalCode: address.postalCode,
                                    city: address.city,
                                    country: address.country,
                                    email: address.email || '',
                                    phone: address.phone || '',
                                    instructions: address.instructions,
                                    startTime: address.startTime,
                                    endTime: address.endTime,
                                    isBusiness: address.isBusiness || false,

                                    gpsRequired: !!address.gpsRequired,
                                    signatureRequired: !!address.signatureRequired,
                                    nameRequired: !!address.nameRequired,
                                    signatureNeighbors: !!address.signatureNeighbors,
                                    scanRequired: !!address.scanRequired,
                                    imageRequired: !!address.imageRequired,
                                    statedAddressOnly: !!address.statedAddressOnly,
                                    mailboxDelivery: !!address.mailboxDelivery,
                                    refrigerated: !!address.refrigerated,
                                    idCheck: !!address.idCheck,
                                    minimumAge: address.minimumAge ?? undefined,
                                    customOptions: address.customOptions || [],
                                    attachments: address.attachments || []
                                }

                                if (address.position) {
                                    newAddress.position = JSON.parse(JSON.stringify(address.position))
                                }

                                newTemplate.addresses.push(newAddress)
                            })

                            if (template.colli) {
                                newTemplate.colli = []

                                template.colli.forEach((collo) => {
                                    if (collo.barcode) {
                                        newTemplate.colli.push({
                                            type: collo.type,
                                            description: collo.description,
                                            weight: collo.weight,
                                            length: collo.length,
                                            width: collo.width,
                                            height: collo.height,
                                            barcode: 'Barcode'
                                        })
                                    }
                                })
                            }

                            newTemplate.distance = template.distance || 0
                            newTemplate.priceTableId = template.priceTableId || ''
                            newTemplate.price = template.price
                            newTemplate.reference = template.reference
                            newTemplate.notes = template.notes
                            newTemplate.autoRetour = !!template.autoRetour
                            newTemplate.nrOfDeliveries = template.nrOfDeliveries
                            newTemplate.nrOfDaysBeforeRetour = template.nrOfDaysBeforeRetour

                            if (template.retourAddress) {
                                newTemplate.retourAddress = {
                                    instructions: '',
                                    startTime: '00:00',
                                    endTime: '23:59',
                                    ...template.retourAddress
                                }
                            }

                            newTemplate.allowAddCollo = template.allowAddCollo || 'yes'
                            this.editOrderModal.open(newTemplate, true, () => {
                                if (this.editOrderModal.recurrence) {
                                    // to set dtstart
                                    const order = {...this.editOrderModal.state.order}
                                    order.rrule = this.editOrderModal.recurrence.init()
                                    this.editOrderModal.setState({order})
                                }
                            })
                        }}
                        routeTemplates={Object.values(routeTemplates)}
                    />
                )}

                {view === 'routes' &&
                    <Planning
                        reseller={reseller}
                        user={user}
                        selectedBranchIds={selectedBranchIds}
                        viewOrder={(...args) => this.viewOrderModal.open(...args)}
                    />
                }

                <ViewOrderModal
                    reseller={reseller}
                    user={user}
                    history={history}
                    usersObject={usersObject}
                    routes={routes}
                    customers={customers}
                    partners={partners}
                    addressBook={addressBook}
                    editOrder={(...args) => this.editOrderModal.open(...args)}
                    onChangeRoute={this.onChangeRoute.bind(this)}
                    onClickCopy={this.onClickCopy.bind(this)}
                    onClickRemove={this.onClickRemove.bind(this)}
                    onClickPrintLabels={this.onClickPrintLabels.bind(this)}
                    match={this.props.match}
                    ref={(modal) => this.viewOrderModal = modal}
                />

                <EditOrderModal
                    reseller={reseller}
                    customers={customers}
                    users={usersObject}
                    addressBook={addressBook}
                    viewOrder={(...args) => this.viewOrderModal.open(...args)}
                    ref={(modal) => this.editOrderModal = modal}
                    planningDate={orderStartDate}
                />

                <OrderScanModal
                    user={user}
                    history={history}
                    customers={customers}
                    users={usersObject}
                    carriers={carriers}
                    partners={partners}
                    reseller={reseller}
                    routes={routes}
                    filteredOrders={filteredOrders}
                    printerPageSize={printerPageSize}
                    ref={(ref) => this.scanModal = ref}
                />

                <ImportOrders
                    reseller={reseller}
                    user={user}
                    customers={customers}
                    ref={(modal) => this.importModal = modal}
                    addressBook={addressBook}
                    planningDate={orderStartDate}
                />

                <ExportOrders
                    reseller={reseller}
                    onChange={onUpdateReseller}
                    onClickExport={this.onClickExport.bind(this)}
                    open={exportOrdersIsOpen}
                    onClose={() => this.setState({exportOrdersIsOpen: false})}
                />

                <CreateTemplatesPopup
                    ref={(ref) => this.createTemplatesPopup = ref}
                    onConfirm={this.onConfirmCreateTemplates.bind(this)}
                />

                <NotSuppliedOrderPopup reseller={reseller} ref={(ref) => this.notSuppliedOrderPopup = ref} />
                <MancoOrderPopup reseller={reseller} ref={(ref) => this.mancoOrderPopup = ref} />
                <CancelOrderPopup reseller={reseller} ref={(ref) => this.cancelOrderPopup = ref} />
                <OnHoldOrderPopup ref={(ref) => this.onHoldOrderPopup = ref} />
                <AtHubOrderPopup reseller={reseller} ref={(ref) => this.atHubOrderPopup = ref} />
                <RescheduleOrderPopup reseller={reseller} ref={(ref) => this.rescheduleOrderPopup = ref} />
                <ChangeTimeslotPopup ref={(ref) => this.changeTimeslotPopup = ref} />
                <PickupDeliverPopup reseller={reseller} ref={(ref) => this.pickupDeliverPopup = ref} />
                <ReturnOrderPopup reseller={reseller} ref={(ref) => this.returnOrderPopup = ref} />
                <CompleteOrderPopup reseller={reseller} orders={orders} ref={(ref) => this.completeOrderPopup = ref} />
                <Popup ref={(ref) => this.popup = ref} />
                <Popup ref={(ref) => this.alertPopup = ref} />
                <CreatePlanningPopup reseller={reseller} vehicles={this.props.vehicles} routes={Object.values(this.state.routes)} ref={(ref) => this.createPlanningPopup = ref} />
                <EditRouteModal reseller={reseller} users={usersObject} ref={(ref) => this.editRouteModal = ref} />

                <Popup ref={(ref) => this.printPopup = ref} />
                <PdfModal ref={(ref) => this.pdfModal = ref} />
            </Stack>
        )
    }
}

export default withVehiclesHook(Dashboard)
